<template>
  <div class="transaction-item-info">
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-details.pay-type') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.payType }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-details.callback') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-details.order') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-details.callback-url-1') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-details.account') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-details.ttl') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-details.sum') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.transactionAmountPlain }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-details.callback-url-2') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-details.bill-attr') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-details.purpose') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.transactionPurpose }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Transaction } from '@js-app/entities/transaction/Transaction'

export default {
  name: 'TransactionItemTransactionDetailsInfo',
  props: {
    transaction: {
      type: Transaction,
    },
  },
}
</script>
